<template>
  <div>
    <div id="Chart9" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts9() {
      var myChart9 = this.$echarts.init(document.getElementById("Chart9"));
      //配置图表
      var option9 = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2022-01-02",
            "2022-01-03",
            "2022-01-04",
            "2022-01-05",
            "2022-01-06",
            "2022-01-07",
            "2022-01-08",
          ],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value) {
              if (value == "2022-01-02") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 130,
                align: "right",
              },
              b: {
                width: 130,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function () {
                  return "#539cff";
                },
              },
              formatter: function (value) {
                return value + "%";
              },
            },
            position: "left",
            splitNumber:3,
          },
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function () {
                  return "#fcad2a";
                },
              },
              formatter: function (value) {
                return value + "%";
              },
            },
            position: "right",
            splitNumber:3,
          },
        ],
        series: [
          {
            name: "格力电器",
            type: "line",
            // stack: "Total",
            smooth: true,
            symbol: "none",
            color: "#fd4c4c",
            data: [7, 2, 3.2, 2.2, 1.2, 6.2, 5.3],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(253,76,76,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(253,76,76,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            name: "白色家电",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fcad2a",
            data: [30, 35, 41, 46, 40, 61, 97],
            yAxisIndex: 1,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart9.setOption(option9);
    },
  },
  mounted() {
    this.myEcharts9();
  },
};
</script>

<style scoped>
</style>